export default "__VITE_ASSET__DazMrRjT__"